import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { PRODUCT_IMAGE } from '../../data/content';
const trustItems = [{
  icon: ZapIcon,
  label: 'Immediate digital access'
}, {
  icon: CheckIcon,
  label: 'One-time payment · Lifetime access'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-950 pb-12 pt-8 sm:pt-10" data-id="element-172" data-mp="muk3fw3gpw3d">
      <div className="mx-auto w-full max-w-6xl px-5" data-id="element-173" data-mp="qv42j57lj9s5">
        <div className="flex flex-col items-center text-center" data-id="element-174" data-mp="qtt1hd5jcg4q">
          <p className="font-display text-sm font-extrabold uppercase tracking-[0.4em] text-white" data-id="element-175" data-mp="vndns7xrnlo3">
            DR. KARITO
          </p>
          <p className="mt-3 rounded-full border border-brand-500/40 bg-brand-500/10 px-4 py-1.5 text-[0.68rem] font-bold uppercase tracking-[0.16em] text-cyan-bright" data-id="element-176" data-mp="10njk41ezdwci">
            Clinical Route for Erectile Dysfunction™
          </p>

          <h1 className="mt-6 max-w-3xl font-display text-[2rem] font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-177" data-mp="9nj5ny7pdq5v">
            Never Wonder What to Do Next With a Patient With{' '}
            <span className="text-cyan-bright" data-id="element-178" data-mp="3vu951c65s4gs">Erectile Dysfunction</span>
          </h1>

          <p className="mt-5 max-w-2xl text-[1.02rem] leading-relaxed text-slate-300 sm:text-lg" data-id="element-179" data-mp="3rtxj7w227y3q">
            Evaluate, identify relevant risk factors, structure your clinical
            reasoning, and plan follow-up with a practical Clinical Route that
            guides you step by step.
          </p>
        </div>

        <div className="mt-8 grid items-center gap-8 lg:mt-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12" data-id="element-180" data-mp="infrls2pkax8">
          <div className="order-1 lg:order-2" data-id="element-181" data-mp="em49s8q2stzl">
            <img src={PRODUCT_IMAGE} alt="The complete Clinical Route for Erectile Dysfunction: six volumes, algorithms on tablet, quick reference on phone, and printable clinical pearls" className="mx-auto w-full max-w-[520px]" loading="eager" data-id="element-182" data-mp="el2ufs211lc2" />
          </div>

          <div className="order-2 lg:order-1" data-id="element-183" data-mp="35la0uvtw3jzt">
            <div className="rounded-3xl border border-white/10 bg-navy-900 p-5 sm:p-7" data-id="element-184" data-mp="35n392fk5ic9x">
              <p className="text-[0.95rem] leading-relaxed text-slate-300 sm:text-base" data-id="element-185" data-mp="2qvuc1ldx5omr">
                The latest clinical evidence transformed into a practical
                decision-making system designed to help you approach erectile
                dysfunction consultations with greater{' '}
                <span className="font-semibold text-white" data-id="element-186" data-mp="2mvtye2yn9hgr">
                  structure, clarity, and confidence.
                </span>
              </p>
              <p className="mt-4 border-l-2 border-cyan-bright pl-4 text-[0.95rem] font-semibold leading-relaxed text-white" data-id="element-187" data-mp="2cvteofwv4zc1">
                A practical clinical system designed to turn a complex
                consultation into a clear decision pathway.
              </p>

              <div id="hero-cta" className="mt-6" data-id="element-188" data-mp="1vn0jb85ckqnw">
                <CTAButton label="I want the complete Clinical Route" size="lg" data-id="element-189" data-mp="1vnsbsa3ne89y" />
              </div>

              <ul className="mt-6 space-y-2.5" data-id="element-190" data-mp="25ck2yg0vwojt">
                {trustItems.map(item => <li key={item.label} className="flex items-center gap-2.5 text-[0.82rem] font-medium text-slate-300" data-id="element-191" data-mp="20m3m0lxuuksp">
                    <item.icon className="h-4 w-4 shrink-0 text-cyan-bright" aria-hidden="true" data-id="element-192" data-mp="2efcumkdzb2a6" />
                    {item.label}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>;
}